angular.module('impactx.MenuDirectives').directive('ixHighContrast', function () {
    return {
        restrict: 'A',
        templateUrl: 'shared/menu/templates/high-contrast-menu.tmpl.html'
    }
});